const MaterialHeaderConfigurationConstants = {
  allowedMaterialHeaders: [
    'material_ref_id', 'material_code', 'quantity', 'quantity_unit', 'weight', 'weight_unit', 'volume',
    'volume_unit', 'pickup_point', 'ship_to', 'sold_to', 'invoice_amount', 'invoice_number', 'invoice_date', 'mrp',
  ],

  defaultValue: {
    required_fields: {
      material_ref_id: 'Material Unique Number',
      material_code: 'Material Code',
      quantity: 'Quantity',
      quantity_unit: 'Quantity Unit',
      weight: 'Weight',
      weight_unit: 'Weight Unit',
      volume: 'Volume',
      volume_unit: 'Volume Unit',
      pickup_point: 'Pickup',
      ship_to: 'Ship To',
      sold_to: 'Sold To',
      invoice_amount: 'Invoice Amount',
      invoice_number: 'Invoice Number',
      invoice_date: 'Invoice Date',
      mrp: 'MRP',
    },
    custom_fields: [],
    update_combination: [],
  },
};

module.exports = { MaterialHeaderConfigurationConstants };
